import Vue from 'vue'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import router from './router'
import store from './store'
import App from './app'

Vue.use(Element, { size: 'small' })
Vue.prototype.$store = store
Vue.directive('loaded-callback', {
    inserted: function (el, binding, vnode) {
        binding.value(el, binding, vnode)
    }
})
new Vue({
    el: '#app',
    router,
    store,
    render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js